/**
 * Keep in mind this is a heavy function. Only call this on a debounce
 *
 * @param {Element} proseMirrorContainer
 * @param {Element} contentScrollContainer
 * @returns {string}
 */
export function getPmMenuPosition (proseMirrorContainer, contentScrollContainer) {
    const proseMirrorBounding = proseMirrorContainer.getBoundingClientRect()
    const contentScrollBounding = contentScrollContainer.getBoundingClientRect()

    const powerCalculator = proseMirrorContainer.menuPosition === 'top' ? 0.7 : 0.9
    const scrollHeight = contentScrollBounding.bottom * powerCalculator
    return proseMirrorBounding.bottom >= scrollHeight ? 'top' : 'bottom'
}
